<template>
  <div>
    <v-os-popup
      :maxHeightFill="true"
      :title="iframeTitle || iframeParams.title"
      v-model="iframeShow"
      :backHistoryNum="historyList.length"
      :historyHasNativeBack="historyHasNativeBack"
      @close="closeIframeShow"
      container="body"
    >
      <iframe
        ref="recycleIframeRef"
        :src="iframeParams.iframeSrc"
        id="recycle_iframe"
        width="100%"
        height="100%"
        frameborder="0"
      />
    </v-os-popup>
    <AboutPage :info="aboutInfo" :show="aboutInfoShow" @close="aboutInfoShow = false"></AboutPage>
    <RenewType
      :info="renewType"
      :show="renewTypeShow"
      :customDark="customDark"
      @close="renewTypeShow = false"
      @select="selectRenewType"
    ></RenewType>
    <TradeType
      :info="tradeType"
      :show="tradeTypeShow"
      :customDark="customDark"
      @close="tradeTypeShow = false"
      @select="selectTradeType"
    ></TradeType>
    <AddressNew
      v-if="address"
      ref="addressNewPopupRef"
      :addresses="addressList"
      :addressId="address.id"
      :customDark="customDark"
      :isPickUp="true"
      @change="changeAddress"
      @clear="clearAddress"
    />
    <PayMethod
      :info="payMethod"
      :show="payMethodShow"
      :customDark="customDark"
      @close="payMethodShow = false"
      @save="savePayMethod"
    ></PayMethod>
    <PickUpTime
      :info="pickUpTime"
      :show="pickUpTimeShow"
      :customDark="customDark"
      @close="pickUpTimeShow = false"
      @select="selectPickUpTime"
    ></PickUpTime>
  </div>
</template>
<script>
import AboutPage from './about-page'
import RenewType from './renew-type'
import TradeType from './trade-type'
import PayMethod from './pay-method'
import PickUpTime from './pick-up-time'
import AddressNew from 'components/address-popups/address-new'
import MessageEvent from '@/utils/messageEvent'
import app from '@/utils/app'
import env from '@/utils/clientEnv'
export default {
  name: 'Recycle',
  components: {
    AboutPage,
    RenewType,
    TradeType,
    AddressNew,
    PayMethod,
    PickUpTime
  },
  props: {
    iframeParams: {
      type: Object,
      default: () => {
        return {
          title: '',
          url: ''
        }
      }
    },
    iframeShow: Boolean,
    customDark: Boolean
  },
  data() {
    return {
      historyList: [],
      historyHasNativeBack: false,
      targetHistoryTitle: '',
      addressList: [],
      iframeMessage: null,
      iframeTitle: '',
      aboutInfo: {},
      aboutInfoShow: false,
      tradeType: {},
      tradeTypeShow: false,
      renewType: '',
      renewTypeShow: false,
      address: {},
      payMethod: {},
      payMethodShow: false,
      pickUpTime: {},
      pickUpTimeShow: false
    }
  },
  watch: {
    iframeShow(val) {
      if (val) {
        this.historyList = []
      }
    }
  },
  methods: {
    locationTo({ iframeSrc, title }) {
      if (iframeSrc) {
        this.$refs.recycleIframeRef?.contentWindow.location.replace(iframeSrc)
      } else {
        this.$refs.recycleIframeRef?.contentWindow.location.replace('about:blank')
      }
      this.iframeTitle = title
    },
    setIframeTerminal() {
      if (!this.iframeMessage?._targetTerminal) {
        this.iframeMessage.setTargetTerminal(this.$refs.recycleIframeRef?.contentWindow)
      }
    },
    closeIframeShow() {
      console.log('-------')
      console.log(this.historyList.length)
      this.$emit('closeIframe')
      // if (this.historyList.length > 1) {
      //   const len = this.historyList.length
      //   setTimeout(() => {
      //     console.log(0 - (len - 1))
      //     history.go(0 - (len - 1))
      //   }, 500)
      // }
      setTimeout(() => {
        this.historyList = []
        this.historyHasNativeBack = false
      }, 500)
    },
    selectRenewType(type) {
      this.$refs.recycleIframeRef?.contentWindow.postMessage(
        {
          event: 're:change:renewType',
          data: {
            selected: type
          }
        },
        '*'
      )
    },
    selectTradeType(type) {
      // this.setIframeTerminal()
      // this.iframeMessage.emit('re:change:tradeType', {
      //   selected: type
      // })
      this.$refs.recycleIframeRef?.contentWindow.postMessage(
        {
          event: 're:change:tradeType',
          data: {
            selected: type
          }
        },
        '*'
      )
    },
    showAddressPopUp() {
      this.$nextTick(() => {
        if (this.address.id || this.addressList?.length) {
          // this.$refs.addressNewPopupRef.initSelected(this.address)
          this.$refs.addressNewPopupRef.showSelector()
        } else {
          this.$refs.addressNewPopupRef.show(this.address)
        }
      })
    },
    async changeAddress({ address, isEdit = 0 }) {
      // this.setIframeTerminal()
      // this.iframeMessage.emit('re:change:address', { address, isEdit })
      this.$refs.recycleIframeRef?.contentWindow.postMessage(
        {
          event: 're:change:address',
          data: { address, isEdit }
        },
        '*'
      )
    },
    clearAddress(id) {
      // 若弹层内删除已选的地址，需要通知子iframe清空当前选择的地址内容/id
      // 同时将detailv3 store中维护的addressList删除选中数据 - 避免打开弹层时之前的数据未更新。
      // this.setIframeTerminal()
      // this.iframeMessage.emit('re:change:address', { address: null, deleteId })
      this.addressList = this.addressList.filter(v => v.id != id)
      this.$refs.recycleIframeRef?.contentWindow.postMessage(
        {
          event: 're:change:address',
          data: { address: null }
        },
        '*'
      )
    },
    savePayMethod(info) {
      // this.setIframeTerminal()
      // this.iframeMessage.emit('re:change:payMethod', info)
      this.$refs.recycleIframeRef?.contentWindow.postMessage(
        {
          event: 're:change:payMethod',
          data: info
        },
        '*'
      )
    },
    selectPickUpTime(obj) {
      // this.setIframeTerminal()
      // this.iframeMessage.emit('re:change:pickUpTime', obj)
      this.$refs.recycleIframeRef?.contentWindow.postMessage(
        {
          event: 're:change:pickUpTime',
          data: obj
        },
        '*'
      )
    },
    confirmSpec(params) {
      // this.setIframeTerminal()
      // this.iframeMessage.emit('re:change:sku', params)
      this.$refs.recycleIframeRef?.contentWindow.postMessage(
        {
          event: 're:change:sku',
          data: params
        },
        '*'
      )
    },
    changeRenewTypeShow(params) {
      this.renewType = params
      this.renewTypeShow = true
    },
    changeTradeTypeShow(params) {
      this.tradeType = { ...params }
      this.tradeTypeShow = true
    },
    showPagePopup({ url, title }) {
      this.aboutInfo = {
        pageUrl: url,
        title: title
      }
      this.aboutInfoShow = true
    },
    changeAddressShow({ address, list }) {
      this.address = {
        ...address
      }
      this.addressList = (list || []).map(item => {
        item.isDefault = item.isDefault == 'true'
        return item
      })
      this.showAddressPopUp()
    },
    changePayMethodShow(params) {
      this.payMethod = { ...params }
      this.payMethodShow = true
    },
    changePickUpTimeShow(params) {
      this.pickUpTime = { ...params }
      this.pickUpTimeShow = true
    },
    changeRecycleSkuShow(params) {
      this.$emit('showSkuSelect', {
        source: 20, // 一站式换新更换规格弹层
        params
      })
    },
    renewSubmit(params) {
      this.$emit('submit', params)
      // this.closeIframeShow()
    }
  },
  created() {
    this.iframeMessage = new MessageEvent({
      currentTerminal: window,
      // targetTerminal: document.getElementById('recycleIframeParams').contentWindow,
      targetOrigin: '*'
    })
    this.iframeMessage.on('change:history', ({ url, type, title }) => {
      if (!this.iframeShow) return
      this.targetHistoryTitle = title
      if (this.historyList.length == 0) {
        this.historyList.unshift(url)
      } else if (title == '精准估价') {
        type == 'forwards' ? this.historyList.unshift(url) : this.historyList.shift()
      } else {
        if (this.historyList.length > 1) {
          const prePath = this.historyList[1]
          const matchIndex = this.historyList.indexOf(url)
          console.log(matchIndex, this.historyList.length)
          if (prePath == url) {
            this.historyList.shift()
            this.historyHasNativeBack = false
          } else if (matchIndex == this.historyList.length - 1 && env.isVivoApp && !env.isIOSVivoApp) {
            // 说明在android APP内触发了物理返回键返回到第一级页面, 如果这个时候触发弹层关闭，直接走app.back。
            this.historyHasNativeBack = true
            this.historyList = [url]
          } else {
            this.historyList.unshift(url)
            this.historyHasNativeBack = false
          }
        } else {
          const prePath = this.historyList[0]
          if (prePath == url) {
            this.historyList.shift()
            this.historyHasNativeBack = false
          } else {
            this.historyList.unshift(url)
            this.historyHasNativeBack = false
          }
        }
      }
    })
    this.iframeMessage.on('change:title', data => {
      this.iframeTitle = data
      if (data == '精准估价' && this.historyList.length > 0 && this.targetHistoryTitle != data) {
        this.historyList.shift()
      }
    })
    // 换新规则、协议弹层展示
    this.iframeMessage.on('show:page', this.showPagePopup)
    this.iframeMessage.on('show_page', this.showPagePopup)
    // 更换换新方式
    this.iframeMessage.on('change:renewType', this.changeRenewTypeShow)
    // 更换交易方式
    this.iframeMessage.on('change:tradeType', this.changeTradeTypeShow)
    // 更换规格 - TODO
    this.iframeMessage.on('change:sku', this.changeRecycleSkuShow)
    // 修改取件地址
    this.iframeMessage.on('change:address', this.changeAddressShow)
    // 修改收款方式
    this.iframeMessage.on('change:payMethod', this.changePayMethodShow)
    // 修改取件时间
    this.iframeMessage.on('change:pickUpTime', this.changePickUpTimeShow)
    this.iframeMessage.on('submit:renew', this.renewSubmit)
    this.iframeMessage.on('trigger:login', () => {
      app.login()
    })
  }
}
</script>
<style lang="less" scoped></style>
